// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Uk","zenCrossSiteLabel":"Vk","vrsnlCrossSiteLabel":"Wk"};